import { useFeatureGate } from '@trello/feature-gate-client';
import { useBoardId } from '@trello/id-context';

import { useIsInboxBoard } from 'app/src/components/Inbox';
import { useBoardAutoArchivePrefFragment } from './BoardAutoArchivePrefFragment.generated';

export const useIsInboxAutoArchiveEnabled: () => boolean = () => {
  const { value: isInboxAutoArchiveM1GateEnabled } = useFeatureGate(
    'phx_inbox_auto_archive_m1',
  );

  const { value: isInboxAutoArchiveM2GateEnabled } = useFeatureGate(
    'phx_inbox_auto_archive_m2',
  );

  const { value: isInboxAutoArchiveOverrideEnabled } = useFeatureGate(
    'phx_inbox_auto_archive_override',
  );

  const isInboxBoard = useIsInboxBoard();
  const boardId = useBoardId();

  const { data: boardAutoArchivePref } = useBoardAutoArchivePrefFragment({
    from: { id: boardId },
  });

  const autoArchiveBoardPref = boardAutoArchivePref?.prefs?.autoArchive;

  return Boolean(
    isInboxBoard &&
      (isInboxAutoArchiveOverrideEnabled ||
        ((isInboxAutoArchiveM1GateEnabled || isInboxAutoArchiveM2GateEnabled) &&
          autoArchiveBoardPref)),
  );
};
